import { CommonModule } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GetCareNowFormatService } from '../../../utilities/getcarenow-format.service';
import { environment } from '../../../../../environments/environment';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-primary-care-provider-option-card-mobile',
  imports: [CommonModule, TranslateModule, MatCardModule, MatButtonModule],
  templateUrl: './primary-care-provider-option-card.component.html',
  styleUrls: ['../../../../../styles.css']
})
export class PrimaryCareProviderOptionCardComponent {
  @Input() providerId!: string;
  @Input() departmentId!: string;
  @Input() name!: string;
  @Input() city!: string;
  @Input() phone!: string;
  @Input() availability!: string;
  @Input() distance!: string;
  @Input() specialties!: string;
  @Input() photo!: string;
  @Input() isPcp!: boolean;
  @Input() specialtyId!: string;
  @Input() locale: string | null = null;
  @Input() pcpId: string | null = null;
  @Input() isOpenScheduling!: boolean;


  environment: any = environment;
  public soonAsText: string = 'AS_SOON_AS';
  public milesAwayText: string = 'DESCRIPTION';
  public scheduleText: string = 'SCHEULE';
  public callText: string = 'CALL';
  public today: string = 'TODAY';
  public tomorrow : string = 'TOMORROW';  
  public noAvailabilityStr: string = 'NO_AVAILABILITY';
  public waitTime: string = '';
  public hasPCP: boolean = false;
  public schedulingWorkflow: string = '';

  private getCareNowFormatService: GetCareNowFormatService;

  
  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem('locale') || 'en-US'); // Default to 'en-US' if no locale is provided
    this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
  }

  ngOnInit(): void {

    this.waitTime = this.getCareNowFormatService.formatNextAvailability(this.availability);

    this.translate.get('BOOK_AS_SOON_AS').subscribe((translated: string) => {
      this.soonAsText = translated;
    });

    this.translate.get('MILES_AWAY').subscribe((translated: string) => {
      this.milesAwayText = translated;
    });

    this.translate.get('SCHEDULE').subscribe((translated: string) => {
      this.scheduleText = translated;
    });

    this.translate.get('CALL').subscribe((translated: string) => {
      this.callText = translated;
    });

    this.translate.get('CALL_TO_SCHEDULE').subscribe((translated: string) => {
        this.noAvailabilityStr = translated;
      });

    this.hasPCP = sessionStorage.getItem("hasPCP") != null ? sessionStorage.getItem("hasPCP") === 'true'  : false;  
  }

  bookNow() {
    const isMobileLaunch = window.location.href.includes('mobile');
    const isPlus = sessionStorage.getItem("isPlus") != null ? sessionStorage.getItem("isPlus") === 'true'  : null;
    const eptID = sessionStorage.getItem("eptID") ?? "";

    if (eptID == null || eptID.length === 0) {
      this.bookNowUnauth(isMobileLaunch);
    } else {
      this.bookNowAuth(isPlus);
    }

  }

  bookNowAuth(isPlus: boolean | null) {
    
    var deepLink = ''; 

    if (isPlus == null) {
      deepLink = environment.web_scheduling_deep_link_base_url; // Default to web scheduling deep link if isPlus is not set
      
      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'PCP', platform: 'web' }); // log as web event
    }
    else {
      deepLink = isPlus
        ? environment.mobile_scheduling_deep_link_base_url // For Plus users, use the mobile deep link
        : environment.epic_scheduling_deep_link_base_url; //  For non-Plus users, use the epic deep link

      var mobilePlatform = isPlus ? 'mobile-plus' : 'mobile-standard';
      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'PCP', platform: mobilePlatform}); // log as mobile or web event
    }

    this.schedulingWorkflow = this.hasPCP == true ? "ExistingProvider" : "NewProvider";

    deepLink += "?workflow=" + this.schedulingWorkflow;
    deepLink += "&linksource=AUTHPCPSCHED";

    // PCP Deeplink ==> .../scheduling?workflow=ExistingProvider&selProvId={pcpID}&selRfvId=61&selDepId={depID}
    if (this.isPcp == true) {
      deepLink += "&selProvId=" + this.providerId + "&selRfvId=" + environment.office_visit_rfv_id; 
    
      if (this.departmentId != null && this.departmentId != '') {
        deepLink += "&selDepId=" + this.departmentId;
      }
    }
    // SUBJECT TO CHANGE
    // Subgroup Provider Deeplink ==> .../scheduling?workflow=ExistingProvider&provID={providerID},{pcpID}&selRfvId=61&DeptID={depID}
    else if (this.isPcp == false && this.hasPCP == true && this.pcpId != null && this.pcpId != '') {
      deepLink += "&provID=" + this.pcpId + "," + this.providerId + "&selRfvId=" + environment.office_visit_rfv_id;
    
      if (this.departmentId != null && this.departmentId != '') {
        deepLink += "&DeptID=" + this.departmentId;
      }
    }
    // Patient with no PCP, open scheduling provider(s) Deeplink ==> .../scheduling?workflow=NewProvider&selProvId={providerID}&selRfvId=61&selDepId={depID}&selSpecialtyId={specialtyId}
    else if (this.isPcp == false && this.hasPCP == false) {
      deepLink += "&selProvId=" + this.providerId + "&selRfvId=" + environment.office_visit_prc_id + "&selSpecialtyId=" + this.specialtyId;
      
      if (this.departmentId != null && this.departmentId != '') {
        deepLink += "&selDepId=" + this.departmentId;
      }
    }


    console.log("book now clicked (PCP)");
    console.log(deepLink);
      
    window.location.href = deepLink;
  }

  bookNowUnauth(isMobileLaunch: boolean) {

    // mobile PCP Deeplink ==> mymemorialcare://MyChartTST/openscheduling/standalone?id={pcpID}&vt=50317
    var deepLink = isMobileLaunch ? environment.mobile_open_scheduling_deep_link_base_url : environment.web_open_scheduling_deep_link_base_url;
    var platform = isMobileLaunch ? 'mobile-plus' : 'web';

    this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'get-care-now', subfeature: 'PCP', platform: platform }); // log as web event

    deepLink += "/standalone"; // Use standalone workflow for unauthenticated users)
    deepLink += "?id=" + this.providerId + "&vt=" + environment.office_visit_prc_id;
    deepLink += "&linksource=PLUAPCV";

    console.log("book now clicked (PCP)");
    console.log(deepLink);
    
    
    window.location.href = deepLink;

  }

  callNow() {
    const isPlus = sessionStorage.getItem("isPlus") != null ? sessionStorage.getItem("isPlus") === 'true'  : null;
    var deepLink = `tel:${this.phone}`;

    if (isPlus == null) {
      this.monitoringService.logEvent('Call', { feature: 'get-care-now', subfeature: 'PCP', platform: 'web' }); // log as web event
    }
    else {
      var mobilePlatform = isPlus ? 'mobile-plus' : 'mobile-standard';
      this.monitoringService.logEvent('Call', { feature: 'get-care-now', subfeature: 'PCP', platform: mobilePlatform}); // log as mobile or web event
    }
   
    console.log("Call clicked (PCP)");
    console.log(deepLink);
      
    window.location.href = deepLink;
  }

  formatNextAvailability(availability: string): string {
    return this.getCareNowFormatService.formatNextAvailability(availability);
  }
}
